<template>
  <section :class="$style.view" v-if="page.fields">
    <ul :class="$style.list">
      <li
        v-for="(work, index) in shuffledItems"
        :key="`work-${index}`"
        :class="$style.item"
        :style="itemWidth(work)"
      >
        <router-link :to="work.meta.url" :class="$style.link">
          <div :class="$style.image">
            <base-image :image="work.fields.images[0]" :sizes="sizes(work)" />
          </div>
        </router-link>
        <div :class="$style.title">
          <span v-html="work.fields.title" />
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
import PageService from '@/services/page'
import BaseImage from '@/components/base-image.vue'

export default {
  components: {
    BaseImage
  },
  metaInfo() {
    return {
      title: this.page.fields ? this.page.fields.title : ''
    }
  },
  data() {
    return {
      page: {}
      // width: 0,
      // size: 0,
      // mq: {
      //   medium: 768
      // }
    }
  },
  methods: {
    // TODO: more elegant solution than accessing the DOM directly: using vue-mq?
    // viewportWidth() {
    //   this.size = window.innerWidth
    //   return this.size
    // },
    itemWidth(item) {
      // if (this.size < this.mq.medium) return
      const factor = item.fields.multiplier.title
      const width = factor * 100
      return {
        width: width + '%'
      }
    },
    sizes(item) {
      const factor = item.fields.multiplier.title
      const width = factor * 50 + 'vw'
      return '(min-width: 768px) ' + width + ', 100vw'
    }
  },
  computed: {
    shuffledItems() {
      // let shuffled = this.page.children.slice()

      // for (let i = shuffled.length - 1; i > 0; i--) {
      //   const random = Math.floor(Math.random() * (i + 1));
      //   [shuffled[i], shuffled[random]] = [shuffled[random], shuffled[i]]
      // }
      // return shuffled
      return this.page.children
    }
  },
  async created() {
    this.page = await PageService.get({ id: this.$route.name })
  }
  // mounted() {
  //   this.viewportWidth()
  //   window.addEventListener('resize', () => {
  //     this.viewportWidth()
  //   })
  // },
  // destroyed() {
  //   window.removeEventListener('resize', () => {
  //     this.viewportWidth()
  //   })
  // }
}
</script>

<style lang="scss" module>
.list {
  padding: var(--gutter);
  padding-top: calc(var(--blank-line) * 7.2);

  @media (min-width: $xxsmall) {
    padding-top: calc(var(--blank-line) * 5.4);
  }

  @media (min-width: $medium) {
    column-count: 2;
    padding-top: calc(var(--blank-line) * 4.8);
  }
}

.item {
  padding: 0 0 var(--gutter) 0;

  // Override inline styles applied by itemWidth()
  @media (max-width: calc(#{$medium} - 0.01em)) {
    width: 100% !important;
  }

  @media (min-width: $medium) {
    &:nth-of-type(odd) {
      // > div {
      //   margin-right: auto;
      // }
      margin-right: auto;
    }

    &:nth-of-type(even) {
      margin-left: auto;
    }
  }

  @media #{$mqHover} {
    &:hover {
      .title {
        opacity: 1;
        visibility: visible;
        transition: opacity var(--short) ease, visibility var(--short) ease;
      }
    }
  }
}

.link {
  display: block;
}

.title {
  display: none;
  // position: fixed;
  // z-index: 2;
  // top: 0;
  // left: 0;
  // width: 100%;
  // padding: var(--gutter);
  // background-color: var(--white);
  // opacity: 0;
  // visibility: hidden;
  // transition: opacity var(--short) ease 175ms,
  //   visibility var(--short) ease 175ms;
  // pointer-events: none;

  // span {
  //   @extend %ff-medium;
  //   @extend %fs-title;
  // }
}

.contact {
  padding: 0 0 var(--gutter) var(--gutter);
}
</style>
